import React, { Component } from 'react';
import _ from 'lodash';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip
} from 'reactstrap';
import BootstrapTable2 from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Service from './services';
import Loader from '../../../commons/loader';
import { PaginationTotal } from '../../../commons/controls';
import NetworkEmptyState from '../../../commons/networkemptystate';
import DataEmptyState from '../../../commons/dataemptystate';
import Selector from './Selector';
import Utility from './Utility';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import Lib from '../../../commons/lib';

class User extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dolgozoJSON: [],
      dolgozoList: [],
      dolgozoOptions: [],
      dolgozoSelected: null,
      dolgozoViewList: [],
      insert: true,
      modalUser: false,
      modalUserDelete: false,
      modalUserView: false,
      userJSON: [],
      userOptionJSON: [],
      userSelected: {},
      visszaigazolasCheck: false,
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'LOAD',
    };

    this.options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ]
    };
  }

  componentDidMount() {
    this.updateTable();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeTab !== '3' && this.props.activeTab === '3') {
      this.updateTable();
    }
  }

  updateTable = () => {
    this.setState({ tableStatus: 'LOAD' }, () => {
      Service.listUsers((err, res) => {
        if (!err) {
          let status = res[0].length == 0 ? 'DATA' : 'TABL';
          this.setState({ userJSON: res[0], tableStatus: status });
        } else {
          this.setState({ tableStatus: 'NETW' });
        }
      });
      Service.listUsersKeycloak((err, res) => {
        if (!err) {
          this.setState({ userOptionJSON: res[0] }, () => {
            this.convertUserJsonToOptions();
          });
        }
      });
      Service.listAllDolgozo((err, res) => {
        if (!err) {
          this.setState({ dolgozoJSON: res[0] }, () => {
            this.convertDolgozoJsonToOptions();
          });
        }
      });
    });
  }

  toggleUserView = () => {
    this.setState((prevState) => { return { modalUserView: !prevState.modalUserView } });
  }

  toggleUser = () => {
    this.setState((prevState) => { return { modalUser: !prevState.modalUser }; });
  }

  toggleUserTorles = () => {
    this.setState((prevState) => { return { modalUserDelete: !prevState.modalUserDelete }; });
  }

  handleDolgozoAddClick = () => {
    this.setState({ insert: true, dolgozoList: [], dolgozoSelected: null, userSelected: {} });
    this.toggleUser();
  }

  handleDolgozoViewClick = (userid) => {
    const user = this.state.userJSON.find(element => element.userid === userid);
    let dolgozoViewList = [];
    for (let dolgozo of user.dolgozok) {
      for (let option of this.state.dolgozoOptions) {
        if (dolgozo.id == option.props.value) {
          Utility.insertByOrder(dolgozoViewList, <div>{option.props.children}<br /></div>);
          break;
        }
      }
    }
    this.setState({ userSelected: user, dolgozoViewList });
    this.toggleUserView();
  }

  handleDolgozoEditClick = (userid) => {
    const user = this.state.userJSON.find(element => element.userid === userid);
    let dolgozoList = [];
    for (let option of this.state.dolgozoOptions) {
      for (let dolgozo of user.dolgozok) {
        if (dolgozo.id == option.props.value) {
          dolgozoList.push(
            <option value={option.props.value}>
              {option.props.children}
            </option>
          );
        }
      }
    }
    this.setState({ userSelected: user, insert: false, dolgozoList, dolgozoSelected: null });
    this.toggleUser();
  }

  handleDolgozoDeleteClick = (userid) => {
    this._currentDeleteId = userid;
    this.toggleUserTorles();
  }

  handleDolgozoSetState = (obj) => {
    let obj2 = {};
    if (obj.hasOwnProperty('elementSelected'))
      obj2.dolgozoSelected = obj.elementSelected
    if (obj.hasOwnProperty('list'))
      obj2.dolgozoList = obj.list;
    if (obj.hasOwnProperty('options'))
      obj2.dolgozoOptions = obj.options;
    this.setState(obj2);
  }

  iconFormatter = (cell,obj) => {
    return (
      <div>
        {
          <div>
            <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekintes'} onClick={() => this.handleDolgozoViewClick(obj.userid)} />
            <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleDolgozoEditClick(obj.userid)} />
            <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleDolgozoDeleteClick(obj.userid)} />
          </div>
        }
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'megtekintes'} delay={0}>Megtekintés</UncontrolledTooltip>
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'modositas'} delay={0}>Módosítás</UncontrolledTooltip>
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'torles'} delay={0}>Törlés</UncontrolledTooltip>
      </div>
    );
  }

  hasCheck = (string) => {
    return string.substr(string.length - 2, 1) == '✓';
  }

  insertStateFieldsIntoObject = (userObj) => {
    userObj.dolgozok = this.state.dolgozoList.map((option) => { return { id: option.props.value } });
  }

  addUser = (event, userObj) => {
    this.insertStateFieldsIntoObject(userObj);
    if (userObj.dolgozok.length == 0) {
      this.props.globals.addError('Legalább egy dolgozó kiválasztása kötelező!');
    } else {
      Service.addUser(userObj, (err) => {
        console.log(err);
        if (!err) {
          this.toggleUser();
          this.updateTable();
          this.props.globals.addSuccess('Dolgozó hozzáadva!');
        }
      });
    }
  }

  modifyUser = (event, userObj) => {
    this.insertStateFieldsIntoObject(userObj);
    if (userObj.dolgozok.length == 0) {
      this.props.globals.addError('Legalább egy dolgozó kiválasztása kötelező!');
    } else {
      userObj.id = this.state.userSelected.id;
      Service.editUser(userObj, (err) => {
        if (!err) {
          this.updateTable();
          this.toggleUser();
          this.props.globals.addSuccess('Dolgozó módosítva!');
        }
      });
    }
  }

  deleteUser = () => {
    console.log('a');
    Service.deleteUser(this._currentDeleteId, (err, res) => {
      console.log(err);
      console.log(res);
      if (!err) {
        console.log('abc');
        this.updateTable();
        this.props.globals.addSuccess('Dolgozó törölve!');
        this.toggleUserTorles();
      }
    });
  }

  convertUserJsonToOptions = () => {
    let mezok = [];
    let array = Array.from(this.state.userOptionJSON);
    array.sort((a, b) => { return a.username.localeCompare(b.username) });
    for (let user of array) {
      mezok.push(<option value={user.id}>{user.username + ' (' + user.szemelynev + ')'}</option>);
    }
    this.setState({ userOptions: mezok });
  }

  convertDolgozoJsonToOptions = () => {
    let mezok = [];
    let array = Array.from(this.state.dolgozoJSON);
    array.sort((a, b) => { return a.nev.localeCompare(b.nev) });
    for (let dolgozo of array) {
      mezok.push(<option value={dolgozo.id}>{dolgozo.nev}</option>);
    }
    this.setState({ dolgozoOptions: mezok });
  }

  loadDolgozoElement = (obj) => {
    this.setState({ dolgozoSelected: obj });
  }

  renderTable = () => {
    const columns = [
      {
        dataField: 'usernev',
        text: 'Felhasználó név',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'szemelynev',
        text: 'Személy név',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter
      }
    ];

    return (
      <BootstrapTable2
        bootstrap4
        keyField="userid"
        data={this.state.userJSON}
        columns={columns}
        filter={filterFactory()}
        pagination={paginationFactory(Lib.bootstraptableProps)}
      />
    );
  }

  renderState = () => {
    switch (this.state.tableStatus) {
      case 'NETW':
        return <NetworkEmptyState hasImage submitClick={this.updateTable} />;
      case 'DATA':
        return <DataEmptyState hasImage />;
      case 'TABL':
        return this.renderTable();
      case 'LOAD':
        return <Loader />;
    }
  }

  renderDataView = () => {
    const {
      userSelected,
      dolgozoViewList
    } = this.state;
    return (
      <div>
        <b>Név: </b>{userSelected && (userSelected.usernev + ' (' + userSelected.szemelynev + ')')}<br />
        <b>Dolgozók: </b>{dolgozoViewList}<br />
      </div>
    );
  }

  render() {
    const {
      userSelected,
      insert,
      modalUser,
      modalUserDelete,
      modalUserView,
      dolgozoList,
      dolgozoOptions,
      dolgozoSelected,
      userOptions,
    } = this.state;
    const dolgozoStateData = {
      elementSelected: dolgozoSelected,
      list: dolgozoList,
      options: dolgozoOptions,
    };
    return (
      <div>
        <div className="row">
          {
            <div className="col-sm-12">
              <Button className="pull-left table-new-button" color="primary" onClick={this.handleDolgozoAddClick}>Új jogosultság </Button>
            </div>
          }
        </div>
        {this.renderState()}
        <Modal isOpen={modalUser} toggle={this.toggleUser} className={this.props.className} backdrop="static">
          <RFForm
            modal
            onSubmit={insert ? this.addUser : this.modifyUser}
            title={"Felhasználó " + (insert ? "felvétel" : "módosítás")}
            footer={
              <>
                <Button color="primary">{'Mentés'}</Button>{' '}
                <Button color="secondary" onClick={this.toggleUser}>Mégsem</Button>
              </>
            }
          >
            <div className="row">
              <div className="col-md-12">
                  <RFField
                    label="Felhasználó: *"
                    name="userid"
                    id="userid"
                    type="select"
                    value={userSelected.userid}
                    errorMessage="Kötelező mező!"
                    disabled={!insert}
                    required
                    defaultSelect={<option value={''} disabled>Válassz felhasználót...</option>}
                    selectOptions={userOptions}
                  />
              </div>
              <div className="col-md-12">
                <Selector
                  setState={this.handleDolgozoSetState}
                  loadElementSelected={this.loadDolgozoElement}
                  stateData={dolgozoStateData}
                  listLabel='Dolgozók:'
                  selectorDefaultOptionName='Válassz dolgozót...'
                  selectorLabel='Dolgozó:'
                />
              </div>
            </div>
          </RFForm>
        </Modal>
        <Modal isOpen={modalUserDelete} toggle={this.toggleUserTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Biztosan törölni szeretnéd ezt a felhasználót?</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.deleteUser}>OK</Button>
            <Button color="secondary" onClick={this.toggleUserTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={modalUserView} toggle={this.toggleUserView} className={this.props.className} backdrop="static">
          <ModalHeader>Megtekintés</ModalHeader>
          <ModalBody>{this.renderDataView()}</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggleUserView}>Vissza</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default User;
